import React from 'react'
import { Edit, SaveButton, SimpleForm, Toolbar, translate } from 'react-admin'
import ColorPicker from './ColorPicker'
import CustomImage from './CustomImage'

export const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton redirect={false} label="ra.action.save" />
  </Toolbar>
)

const BrandingEdit = ({ accessible, dispatch, recordLiveValues, roles, translate, ...props }) => {
  return (
    <Edit id="branding" {...props}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <CustomImage source="logo" placeholder={<p>{translate('main.drop_image', { _: 'Drop your image here' })}</p>} />
        <ColorPicker {...props} />
      </SimpleForm>
    </Edit>
  )
}

export default translate(BrandingEdit)
